import React from 'react'

export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.0405 12.7071C9.64996 13.0976 9.01679 13.0976 8.62627 12.7071L4.62627 8.70711C4.23574 8.31658 4.23574 7.68342 4.62627 7.29289L8.62627 3.29289C9.01679 2.90237 9.64996 2.90237 10.0405 3.29289C10.431 3.68342 10.431 4.31658 10.0405 4.70711L6.74759 8L10.0405 11.2929C10.431 11.6834 10.431 12.3166 10.0405 12.7071Z" fill="#194074"/>
  </svg>

)
